<template>
  <b-container
    fluid
    class="nft-playground "
    v-bind:class="{ smooth_collapse: set_class }"
    ref="nftPlayground"
  >
    <b-row>
      <b-col id="reset_here">
        <div class="text-container">
          <img
            src="@/assets/rebrand/home/the-nft-playground.png"
            alt="the nft playground"
            class="img-nft-title"
          />
          <img
            src="@/assets/rebrand/home/nft-subtitle.png"
            alt="the nft subtitle"
            class="img-nft-subtitle"
          />
          <!-- <img src="@/assets/rebrand/nft-text.svg" alt="the nft text" class="img-nft-text" /> -->
          <p class="nft-desc -wb">
            We are SNKRHUD, an NFT-based playground set <br />
            in <span class="violet">Earth-326</span>, a post-apocalyptic world where <br />
            sneakers rule. <br />
            <br />
            <sub>
              Your kicks are your currency. They establish your status in the <br />
              community, earning <span class="orange">Tags</span> and increasing your
              <span class="orange">Level</span>. Create personal <br />
              digital collectibles, called <span class="orange">DED Stock</span> (Digitally Enabled
              Dopeness), <br />
              based on photos you take of your shoes. Your trusted
              <span class="orange">Side Kick </span>uses<br />
              available DED Stock (whether created or purchased) to unlock <br />
              Bot-to-Bot Battles, winning SNKRCred and upgrades for your <br />
              <span class="orange">Battle Bots</span> in the quest of building your ultimate sneaker
              legacy. <br /><br />

              SNKRHUD is built on the Flow blockchain, which means zero gas <br />
              fees, easy onboarding, and participation in the next revolution in <br />
              Sneaker Culture by enabling web3 technologies. <br /><br />
              All you need to start is a pair of kicks and your power to<br />
            </sub>
          </p>

          <div class="-mb" id="collapse_here">
            <b-button v-b-toggle.collapse-nft class="btn-collapse-nft" @click="scrollNow">
              <h5>explore earth-326</h5>
            </b-button>
            <b-collapse id="collapse-nft" class="mt-2 collapse-features">
              <b-card>
                <p class="desc-nft">
                  We are SNKRHUD, an NFT-based playground set <br />
                  in <span class="violet">Earth-326</span>, a post-apocalyptic world where <br />
                  sneakers rule. <br />
                </p>

                Your kicks are your currency. They establish your status in the community, earning
                <span class="orange">Tags</span> and increasing your
                <span class="orange">Level</span>. Create personal digital collectibles, called
                <span class="orange">DED Stock</span> (Digitally Enabled Dopeness), based on photos
                you take of your shoes. Your trusted <span class="orange">Side Kick </span>uses
                available DED Stock (whether created or purchased) to unlock Bot-to-Bot Battles,
                winning SNKRCred and upgrades for your <span class="orange">Battle Bots</span> in
                the quest of building your ultimate sneaker legacy. <br /><br />

                SNKRHUD is built on the Flow blockchain (link), which means zero gas fees, easy
                onboarding, and participation in the next revolution in Sneaker Culture by enabling
                web3 technologies. <br /><br />
                All you need to start is a pair of kicks and your power to<br />

                <div class="btn-nft-container">
                  <b-button class="btn-create" @click="scrollToCarousel(0)">
                    <img src="@/assets/rebrand/home/create.png" alt="create" class="img-create" />
                  </b-button>
                  <b-button class="btn-collect" @click="scrollToCarousel(1)">
                    <img
                      src="@/assets/rebrand/home/collect.png"
                      alt="collect"
                      class="img-collect"
                    />
                  </b-button>
                  <b-button class="btn-combat" @click="scrollToCarousel(2)">
                    <img src="@/assets/rebrand/home/combat.png" alt="combat" class="img-combat" />
                  </b-button>
                </div>
              </b-card>
            </b-collapse>
          </div>
          <div class="btn-nft-container -wb">
            <b-button class="btn-create" @click="scrollToCarousel(0)">
              <img src="@/assets/rebrand/home/create.png" alt="create" class="img-create" />
            </b-button>
            <b-button class="btn-collect" @click="scrollToCarousel(1)">
              <img src="@/assets/rebrand/home/collect.png" alt="collect" class="img-collect" />
            </b-button>
            <b-button class="btn-combat" @click="scrollToCarousel(2)">
              <img src="@/assets/rebrand/home/compete.png" alt="combat" class="img-combat" />
            </b-button>
          </div>
        </div>
        <b-button class="btn-earth-326 -wb">Earth 326</b-button>
        <img src="@/assets/rebrand/home/shoe1.png" alt="nft shoe" class="img-nft-shoe -wb" />
        <img
          src="@/assets/rebrand/home/shoe-background.png"
          alt="nft shoe"
          class="img-nft-bg -wb"
        />
        <img
          src="@/assets/rebrand/home/shoe-elements.png"
          alt="nft shoe"
          class="img-nft-elements -wb"
        />
        <!-- <img src="@/assets/rebrand/home/nft-shoe.png" alt="nft shoe" class="img-nft-shoe -wb" /> -->
        <img src="@/assets/mobile/NFT-Globe1.png" alt="nft shoe" class="img-nft-shoe -mb" />
      </b-col>
      <img
        src="@/assets/rebrand/home/background.svg"
        alt="nft playground bg"
        class="img-dark-background -wb"
      />
    </b-row>
    <img src="@/assets/mobile/nftplay-shape.png" alt="nftplay shape" class="-mb nftplay-shape" />
    <img
      src="@/assets/mobile/nftplay-shape-2.png"
      alt="nftplay shape"
      class="-mb nftplay-shape-2"
    />
    <img
      src="@/assets/mobile/nftplay-shape-3.png"
      alt="nftplay shape"
      class="-mb nftplay-shape-3"
    />
    <img
      src="@/assets/mobile/nftplay-shape-4.png"
      alt="nftplay shape"
      class="-mb nftplay-shape-4"
    />
    <img
      src="@/assets/mobile/nftplay-shape-5.png"
      alt="nftplay shape"
      class="-mb nftplay-shape-5"
    />
    <img
      src="@/assets/mobile/nftplay-shape-6.png"
      alt="nftplay shape"
      class="-mb nftplay-shape-6"
    />
    <img
      src="@/assets/mobile/nftplay-shape-7.png"
      alt="nftplay shape"
      class="-mb nftplay-shape-7"
    />
    <img
      src="@/assets/mobile/NFTPlayground.png"
      alt="nft playground bg"
      class="img-dark-background -mb"
    />
  </b-container>
</template>
<script>
export default {
  name: 'NftPlayground',
  data() {
    return {
      status: 0,
      set_class: false,
    };
  },
  methods: {
    scrollNow() {
      // if (!this.set_class){
      //     this.set_class = true;
      // }
      // else {
      //     this.set_class = false;
      // }
      // if(this.status == 1){
      //   this.status = 0;
      //   setTimeout(() => {
      //     document.getElementById("reset_here").scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
      //   }, 300)
      // }else{
      //   this.status = 1;
      //   document.getElementById("collapse_here").scrollIntoView({ behavior: "smooth" });
      // }
    },
    scrollToCarousel(slide) {
      const sneakerLegacyRef = this.$store.getters.getSneakerLegacyRef;
      this.$store.commit('setSneakerLegacySlide', slide);
      window.scrollTo(0, sneakerLegacyRef.offsetTop);
    },
  },
};
</script>
